/**
 * RadioInput.
 */

function RadioInput({
		checked,
		name,
		id,
		label,
		onChange,
		disabled,
}) {
	return (
		<div className="dpf_radio">
			<input
				checked={checked}
				className="dpf_radio__input"
				id={id ?? name}
				name={name}
				onChange={(e) => onChange(e.target.value)}
				type="radio"
				disabled={disabled}
			/>
			<label className="dpf_radio__label" htmlFor={id ?? name}>{label}</label>
		</div>
	)
}

export default RadioInput;
